var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"pp-switch",class:{'is-active': _vm.isActive, 'is-disabled': _vm.currentDisabled},style:({ background: (_vm.color && _vm.isActive) ? _vm.color : null }),on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }